module.exports = __webpack_public_path__ + "static/media/icon-report-sidebar-high-score.c77f9d83.svg";